import React from "react";
import { observer } from "mobx-react-lite";
import { Typography } from "@mui/material";
import { useStore } from "../../../helpers";
import { SrAdditionalInfo } from "./sr-additional-info";
import RNAccordion from "../../../components/Accordion";
import { TimelineLog } from "../../../features";
import { useTranslation } from "react-i18next";
import { toJS } from "mobx";

export const SrRequestDetailsInfo = observer((props) => {
    const rootStore = useStore();
    const { serviceRequestsStore } = rootStore;
    const { activeServiceRequest, activelogs } = serviceRequestsStore;
    const { t } = useTranslation("");
    console.log(toJS(activeServiceRequest), "activeServiceRequest");

    return (
        <>
            <div className="mt-3 flex flex-col rounded-xl bg-common-white">
                <div className="p-4">
                    <Typography
                        variant={"h6"}
                        color={"primary"}
                        sx={{
                            fontWeight: 600,
                        }}
                    >
                        {t("requested_details")}
                    </Typography>
                </div>
                <div className="flex flex-col px-4">
                    <div className="flex flex-row items-center justify-between pb-3">
                        <Typography className="font-bold text-common-black">{t("status")}</Typography>
                        <Typography className="rounded-xl bg-label-status px-2 py-1 text-common-white">
                            {activeServiceRequest?.status?.status?.status || "-"}
                        </Typography>
                    </div>
                    {/*<div className="flex flex-row pb-3 items-center justify-between">*/}
                    {/*    <Typography className="font-bold text-common-black">*/}
                    {/*        {t("assignee_label")}*/}
                    {/*    </Typography>*/}
                    {/*    <Typography className="text-common-black">*/}
                    {/*        {activeServiceRequest?.assignee?.assignee?.name ||*/}
                    {/*            "-"}*/}
                    {/*    </Typography>*/}
                    {/*</div>*/}
                    {/*<div className="flex flex-row pb-3 items-center justify-between">*/}
                    {/*    <Typography className="font-bold text-common-black">*/}
                    {/*        {t("assignee_label")}*/}
                    {/*    </Typography>*/}
                    {/*    <Typography className="text-common-black">*/}
                    {/*        {activeServiceRequest?.assignee?.user_profile ||*/}
                    {/*            "-"}*/}
                    {/*    </Typography>*/}
                    {/*</div>*/}
                    <div className="flex flex-row items-center justify-between pb-3">
                        <Typography className="font-bold text-common-black">{t("assignee_label")}</Typography>
                        <Typography className="text-common-black">
                            {activeServiceRequest?.assignee?.is_office_person
                                ? activeServiceRequest?.assignee?.user_profile?.name || "-"
                                : activeServiceRequest?.assignee?.assignee?.name || "-"}
                        </Typography>
                    </div>

                    <div className="flex flex-row items-center justify-between pb-3">
                        <Typography className="font-bold text-common-black">{t("priority")}</Typography>
                        <Typography className="text-common-black">
                            {activeServiceRequest?.priority?.priority?.name || "-"}
                        </Typography>
                    </div>
                    <div className="flex flex-row items-center justify-between pb-3">
                        <Typography className="font-bold text-common-black">{t("req_on")}</Typography>
                        <Typography className="text-common-black">
                            {activeServiceRequest?.more?.requested_date || "-"}
                        </Typography>
                    </div>
                    <div className="flex flex-row items-center justify-between pb-3">
                        <Typography className="font-bold text-common-black">{t("time_visited")}</Typography>
                        <Typography className="text-common-black">
                            {activeServiceRequest?.subject?.more?.enquiry || "-"}
                        </Typography>
                    </div>
                    <div className="flex flex-row items-center justify-between pb-3">
                        <Typography className="font-bold text-common-black">{t("location_label")}</Typography>
                        <Typography className="text-common-black">
                            {activeServiceRequest?.location?.location?.address || "-"}
                        </Typography>
                    </div>
                </div>
                <SrAdditionalInfo />
            </div>
            <div className="mt-3 flex flex-col rounded-xl bg-common-white">
                <div className="p-4">
                    <Typography
                        variant={"h6"}
                        color={"primary"}
                        sx={{
                            fontWeight: 600,
                        }}
                    >
                        {t("logs")}
                    </Typography>
                </div>
                <div className="flex flex-col px-4 pb-4">
                    <RNAccordion title={""} subtitle={"You can see the logs here"}>
                        <TimelineLog
                            timeline_log={activelogs}
                            // @ts-ignore
                            mode={"VERTICAL"}
                        />
                    </RNAccordion>
                </div>
            </div>
        </>
    );
});
